@defer (on timer(0.75s)) {
  @if (loading$ | async) {
    <ui-loading-overlay></ui-loading-overlay>
  }

  <p-toast [key]="DEFAULT_NOTIFICATION_SLOT_KEY" position="bottom-center"> </p-toast>

  <p-toast [key]="ERROR_NOTIFICATION_SLOT_KEY" position="top-center">
    <ng-template let-message #message>
      <span class="p-toast-message-icon" [attr.aria-hidden]="true" [attr.data-pc-section]="'icon'">
        <svg data-p-icon="times-circle" [attr.aria-hidden]="true" [attr.data-pc-section]="'icon'" />
      </span>

      <div class="p-toast-message-text" [attr.data-pc-section]="'text'">
        <div class="p-toast-summary" [attr.data-pc-section]="'summary'">{{ message.summary }}</div>
        <div class="p-toast-detail" [attr.data-pc-section]="'detail'">{{ message.detail }}</div>

        @if (message.data?.explanation) {
          <h5 class="mt-4 mb-0">Detail:</h5>
          <p>{{ message.data.explanation }}</p>
        }
      </div>
    </ng-template>
  </p-toast>
  <ui-router-outlet />
  <reza-ui-session-timeout-dialog></reza-ui-session-timeout-dialog>
} @placeholder {
  <!-- načítací obrazovka; animace v @theme ve styles.css, při omezení pohybu (prefers-reduced-motion) bez animace -->
  <div
    class="fixed inset-0 z-1000 flex flex-col items-center justify-center gap-4 bg-(--background-primary) text-(--text-white-fixed)"
    role="status">
    <svg class="size-16 animate-app-loader-spin motion-reduce:animate-none" viewBox="25 25 50 50" aria-hidden="true">
      <circle
        class="animate-app-loader-dash motion-reduce:animate-none"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round" />
    </svg>
    <p class="m-0 text-(length:--font-size-headline-l) font-normal tracking-wide">načítám&hellip;</p>
  </div>
}
